import React from 'react';
import Toast from './Toast';
import { useToast } from './ToastContext';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  const groupedToasts = toasts.reduce((acc, toast) => {
    const position = toast.position || 'top-right';
    if (!acc[position]) acc[position] = [];
    acc[position].push(toast);
    return acc;
  }, {});

  return (
    <>
      {Object.entries(groupedToasts).map(([position, positionToasts]) => (
        <div key={position} className={`toast-container toast-container--${position}`}>
          {positionToasts.map((toast) => (
            <Toast
              key={toast.id}
              {...toast}
              onClose={removeToast}
            />
          ))}
        </div>
      ))}
    </>
  );
};

export default ToastContainer;